export default __webpack_public_path__ + "static/Circulo-Prateado-77eac977b84edb9f71af878d866ed6a2.png";